import React from 'react';
import { Box, Text, Radio, TextFieldSize, ButtonAppearance } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { PipingContainerStyled } from './styled';
import { PipingFooterButtonStyled, FooterStyled } from './styled';

export const PipingWeldSetup = () => {
  return (
    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
      <PipingContainerStyled data-testid="weld-setup-piping-container">
        <Box mb={{ sm: '600' }} data-testid="weld-setup-piping-header">
          <Text size="500" color="grey.1000" weight="600" family="graphik">
            <Trans>Weld Organization</Trans>
          </Text>
        </Box>
        <Box mb={{ sm: '500' }}>
          <Text size="300" color="grey.1000" family="graphik">
            <Trans>How are welders organized within your project&lsquo;s weld program?</Trans>
          </Text>
        </Box>
        <Box alignItems={{ sm: 'center' }} py={{ sm: '400' }}>
          <Radio name="example" size={TextFieldSize.MEDIUM} id="weld-pool" />
          <Box ml={{ sm: '500' }}>
            <Text size="300" color="grey.1000" family="graphik">
              <Trans>Weld Pool</Trans>
            </Text>
          </Box>
        </Box>
        <Box alignItems={{ sm: 'center' }} py={{ sm: '400' }}>
          <Radio name="example" size={TextFieldSize.MEDIUM} />
          <Box ml={{ sm: '500' }}>
            <Text size="300" color="grey.1000" family="graphik">
              <Trans>Welders are embedded in piping crews</Trans>
            </Text>
          </Box>
        </Box>
        <Box alignItems={{ sm: 'center' }} py={{ sm: '400' }}>
          <Radio name="example" size={TextFieldSize.MEDIUM} />
          <Box ml={{ sm: '500' }}>
            <Text size="300" color="grey.1000" family="graphik">
              <Trans>Hybrid (weld pool & embedded in piping crews)</Trans>
            </Text>
          </Box>
        </Box>
      </PipingContainerStyled>
      <FooterStyled data-testid="weld-setup-piping-footer">
        <PipingFooterButtonStyled appearance={ButtonAppearance.SECONDARY}>
          <Trans>Cancel</Trans>
        </PipingFooterButtonStyled>
        <PipingFooterButtonStyled appearance={ButtonAppearance.SECONDARY}>
          <Trans>Save Changes</Trans>
        </PipingFooterButtonStyled>
      </FooterStyled>
    </Box>
  );
};
